export default __webpack_public_path__ + "static/media/login_lap.13e7037d.png";